module.exports = __webpack_public_path__ + "img/veg_bellpepper.5c4ede8c.png";